const types = {

    TOGGLE_NAVBAR: null,
    HIDE_NAVBAR: null,
    SHOW_NAVBAR: null,

    SUBMIT_USER: 'async',
    ADMIN_LOAD_USERS: 'async',
    ADMIN_LOAD_USER: 'async',
    LOGIN_USER: 'async',
    LOGOUT: 'async',

    SUBMIT_SEASON: 'async',
    ADMIN_LOAD_SEASONS: 'async',
    ADMIN_LOAD_SEASON: 'async',
    LOAD_SEASONS: 'async',

    SUBMIT_PARTNER: 'async',
    ADMIN_LOAD_PARTNERS: 'async',
    ADMIN_LOAD_PARTNER: 'async',
    LOAD_PARTNERS: 'async',
    DELETE_PARTNER: 'async',

    SUBMIT_STAGE: 'async',
    LOAD_STAGES_PAGINATED: 'async',
    DELETE_STAGE: 'async',
    // ADMIN_LOAD_STAGE: 'async',
    ADMIN_UPDATE_STAGE_DISTANCE: 'async',
    LOAD_STAGES: 'async',
    LOAD_STAGE: 'async',
    LOAD_UPCOMING_STAGE: 'async',
    REGISTRATION_TO_CUSTOM: 'async',
    LOAD_STAGE_PARTICIPANTS: 'async',
    SAVE_STAGE_RESULTS: 'async',
    LOAD_STAGE_RESULTS: 'async',
    REGISTRATION_TO_ALL: 'async',

    TOGGLE_DISTANCE_MODAL: null,
    DELETE_DISTANCE: 'async',
    SUBMIT_DISTANCE: 'async',


    SUBMIT_PARTICIPANT: 'async',
    LOAD_PARTICIPANTS_PAGINATED: 'async',
    LOAD_PARTICIPANT: 'async',
    LOAD_PARTICIPANT_BY_UUID: 'async',
    INITIALIZE_PARTICIPANT_FORM_DATA: null,
    DELETE_PARTICIPANT: 'async',
    SUBMIT_PARTICIPANT_RESULT_SEARCH: 'async',
    SUBMIT_ADMIN_PARTICIPANT_RESULT_SEARCH: 'async',
    LOAD_PARTICIPANT_RESULT: 'async',
    SUBMIT_PARTICIPANT_RESULT: 'async',


    SUBMIT_POST: 'async',
    LOAD_POST: 'async',
    LOAD_POSTS: 'async',
    LOAD_POSTS_PAGINATED: 'async',
    DELETE_POST: 'async',

    SUBMIT_SETTINGS: 'async',
    LOAD_SETTINGS: 'async',

    LOAD_RESULTS: 'async',

    LOAD_STATISTICS: 'async',

    LOAD_IMAGES: 'async',
    DELETE_IMAGE: 'async',

    SUBMIT_PARTNER_CATEGORY: 'async',
    ADMIN_LOAD_PARTNER_CATEGORIES: 'async',
    LOAD_PARTNER_CATEGORIES: 'async',
    ADMIN_LOAD_PARTNER_CATEGORY: 'async',
    DELETE_PARTNER_CATEGORY: 'async',


    SUBMIT_PROMO_CODE: 'async',
    ADMIN_LOAD_PROMO_CODE: 'async',
    ADMIN_LOAD_PROMO_CODES: 'async',
    DELETE_PROMO_CODE: 'async',

    ADMIN_LOAD_INVOICE: 'async',
    ADMIN_LOAD_INVOICES: 'async'

};

/*
transforms each value:

{
    FOO: null,
    BAR: 'async'
}

becomes

{
    FOO: 'FOO',
    BAR: {
        REQUEST: 'BAR_REQUEST',
        SUCCESS: 'BAR_SUCCESS',
        FAILURE: 'BAR_FAILURE',
        all: ['BAR_REQUEST' 'BAR_SUCCESS', 'BAR_FAILURE']
    }
}

*/


Object.keys(types).forEach(key => {
    if (types[key] === 'async') {
        types[key] = {
            all: []
        };
        ['REQUEST', 'SUCCESS', 'FAILURE'].forEach(type => {
            const full_type = `${key}_${type}`;
            types[key][type] = full_type;
            types[key].all.push(full_type);
        });
    } else if (types[key] === null) {
        types[key] = key;
    } else {
        throw new Error('type value must be "async" or null');
    }
});

export default types;



// WEBPACK FOOTER //
// ./src/js/actions/types.js